// 화면 11 내부 타입 — API DTO 는 src/api/sectorTaxonomyApi.ts 권위.
// 여기에는 URL 쿼리 동기화, 탭 상태, 리뷰 큐 서브탭 enum 등 UI 전용 구조만 보관.

import type { MappingStatus, TaxonomySource } from '../../api/sectorTaxonomyApi';

export const TAXONOMY_TABS = [
  { id: 'tree', label: '정규 섹터 트리' },
  { id: 'mappings', label: '매핑 테이블' },
  { id: 'review', label: '리뷰 큐' },
  { id: 'balance', label: '밸런싱 지표' },
  { id: 'audit', label: '감사 이력' },
  { id: 'feedback', label: '피드백' },
  // 탭 F — 섹터 유사도 히트맵 (Sprint 1 신규).
  // dashboard-api v1.6 GET /api/v1/sectors/taxonomy/similarity 재사용.
  { id: 'similarity', label: '유사도 히트맵' },
] as const;

export type TaxonomyTabId = (typeof TAXONOMY_TABS)[number]['id'];

export const REVIEW_SUBTABS = [
  { id: 'typeA', label: 'Type-A 대기열' },
  { id: 'typeC', label: 'Type-C 자동 감지' },
  { id: 'unmapped', label: '미매핑 fallback' },
] as const;

export type ReviewSubtabId = (typeof REVIEW_SUBTABS)[number]['id'];

export interface MappingsFilterState {
  sources: TaxonomySource[];
  statuses: MappingStatus[];
  canonicalSectorId: string;
  sourceSectorName: string;
  minConfidence: number;
  page: number;
  pageSize: number;
}

export const DEFAULT_MAPPINGS_FILTERS: MappingsFilterState = {
  sources: [],
  // 기본은 "현재 유효" 만 — confirmed + pending_review. rejected(Phase 1 reset·
  // 운영자 반려·superseded 이력) 는 누적되므로 기본 표시에서 제외.
  // 운영자가 감사 목적으로 보려면 필터 체크로 포함.
  statuses: ['confirmed', 'pending_review'],
  canonicalSectorId: '',
  sourceSectorName: '',
  minConfidence: 0,
  page: 0,
  pageSize: 100,
};

export const ALL_TAXONOMY_SOURCES: TaxonomySource[] = ['naver_primary', 'naver_theme'];
export const ALL_MAPPING_STATUSES: MappingStatus[] = ['confirmed', 'pending_review', 'rejected'];

export function formatTaxonomySource(s: TaxonomySource | string): string {
  switch (s) {
    case 'naver_primary':
      return '네이버 대표';
    case 'naver_theme':
      return '네이버 테마';
    default:
      return s;
  }
}

export function formatMappingStatus(s: MappingStatus | string): string {
  switch (s) {
    case 'confirmed':
      return '확정';
    case 'pending_review':
      return '대기';
    case 'rejected':
      return '반려';
    default:
      return s;
  }
}

export function todayIsoDate(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function shiftIsoDate(daysBack: number): string {
  const d = new Date();
  d.setDate(d.getDate() - daysBack);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
